import {headerMenu} from "./components/headerMenu";
import {footerMenu} from "./components/footerMenu";
import {blogFilters} from "./components/blogFilters";
import {blogIndex} from "./components/blogIndex";
import {liveChat} from "./components/liveChat";
import {activeEmbedBlocks} from "./components/active-embed-blocks";
import {classesOnScroll} from "./components/classesOnScroll";
import {asyncGetDynamicNavigation} from "./components/asyncGetDynamicNavigation";


const appInit = async () => {

    // navigation (async)
    const navigation = await asyncGetDynamicNavigation();
    headerMenu.init(navigation.header);
    footerMenu.init(navigation.footer);


    // other components
    classesOnScroll.init();
    blogFilters.init();
    blogIndex.init();
    liveChat.init();


    // wp
    activeEmbedBlocks.init();

};

appInit().then(() => {
    console.log('app initialized');
});
